import script from "./HistoryCont.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryCont.vue?vue&type=script&setup=true&lang=js"

import "./HistoryCont.vue?vue&type=style&index=0&id=b2b349fe&lang=scss"
import "./HistoryCont.vue?vue&type=style&index=1&id=b2b349fe&lang=scss"

const __exports__ = script;

export default __exports__